export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 12 Impulse Purchase (Part 2).d7d57cd7.mp3";